import { render, staticRenderFns } from "./EducationCard.vue?vue&type=template&id=02a79ba2&"
import script from "./EducationCard.vue?vue&type=script&lang=js&"
export * from "./EducationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports